import { defineStore } from 'pinia';
import configApi from '../api/config';

export const useConfigStore = defineStore('config', {
  state: () => ({
    categories: [],
    mileRanges: [5, 25, 50, 100],
    subscriptionPricing: { monthly: 1, yearly: 12 },
    maxImagesPerListing: 5,
    maxOfferImages: 3,
    loaded: false,
  }),
  actions: {
    async fetch() {
      const data = await configApi.getPublicConfig();
      Object.assign(this, data, { loaded: true });
    },
  },
});
